import { Reducer } from "redux";

import { DocumentDownloadResponse } from "../models/api/Referral";
import { DocumentDownloadActionDispatchTypes } from "../constants/Referral";
import { DocumentDownloadDispatchTypes } from "../models/dispatchTypes/Referral";

const initialState: DocumentDownloadResponse = {
  loading: false,
  response: null,
  error: null,
};

const DocumentDownloadReducer: Reducer<
  DocumentDownloadResponse,
  DocumentDownloadDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentDownloadActionDispatchTypes.DOCUMENT_DOWNLOAD_INVOKE: {
      return {
        ...state,
        response: null,
        loading: true,
        error: null,
      };
    }
    case DocumentDownloadActionDispatchTypes.DOCUMENT_DOWNLOAD_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null,
      };
    }
    case DocumentDownloadActionDispatchTypes.DOCUMENT_DOWNLOAD_ERROR: {
      return {
        ...state,
        error: action.response,
        response: null,
        loading: false,
      };
    }
    case DocumentDownloadActionDispatchTypes.DOCUMENT_DOWNLOAD_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DocumentDownloadReducer;